import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import { QueryLoadingResource } from "../../models/query-loading-resource";
import { QueryFilter } from "./filters/query-filter";
import { Sorting } from "./sorting";

@JsonObject()
export class Query extends QueryLoadingResource {
    @JsonProperty("filter")
    filter: QueryFilter;

    /**
     * The number of items to skip. If not specified, no items will be skipped.
     */
    @JsonProperty("skip")
    skip: number = 0;

    /**
     * The number of items to take. If not specified, the underlying implementation will use a default value.
     */
    @JsonProperty("take")
    take: number = 50;

    /**
     * Indicates how the results should be sorted.
     */
    @JsonProperty("sorting")
    @JsonElementType(Sorting)
    sorting: Array<Sorting>;

    /**
     * If specified, the query will return as {@link QueryResult#scrollId}, which can be used to walk through the set of results without having to use paging.
     */
    @JsonProperty("scroll_time")
    scrollTime?: Date;

    constructor(init?: Partial<Query>) {
        super();
        Object.assign(this, init);
    }
}
